export default __webpack_public_path__ + "static/media/delete.2dba8120.svg";